import { useMutation } from '@tanstack/react-query';
import { apiClient } from 'api';

export interface CandidateProgressCheckPayload {
  assessment: string;
  email: string;
}

export interface CandidateProgressResponse {
  message: string;
  data: {
    candidate: {
      id: number;
      email: string;
    };
    response_data: {
      id: number;
      progress: {
        basic_expectation: boolean;
        work_qualities: boolean;
        work_motivators: boolean;
        work_style: boolean;
        soft_skill: boolean;
        personality: boolean;
        domain_knowledge: boolean;
      };
      questions_answered: number;
      email: string;
      deleted_at: string | null;
      created_at: string;
      updated_at: string;
      full_name: string;
      portfolio: string;
      phone_number: string;
      response_session_id: string;
      resume: string;
      duration_minutes: number;
      duration_minutes_left: number;
      end_time?: string;
      status: string;
      bucket: string;
      total_score: string;
      total_metrics_calculated: number;
      locked: boolean;
      assessment: number;
      candidate: number;
    };
  };
}

export const useCheckCandidateProgress = () => {
  return useMutation({
    mutationFn: async (payload: CandidateProgressCheckPayload) => {
      const response = await apiClient.post<CandidateProgressResponse>(
        '/candidate/check/',
        payload
      );
      return response.data;
    },
  });
};
